<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <b-row v-if="loaded" class="mx-0 mb-3">
      <b-col lg="3">
        <b-card class="mb-3 bg-light shadow">
          <h6 class="card-title">Débiteur</h6>
          <b-row>
            <mh-select
              mh-class="col-12"
              :table="mandat"
              field="debiteurID"
              label="Entrez un débiteur"
              :autocomplete="{
                field: 'debiteur.nom_soc || debiteur.(nom prenom)',
              }"
              @change="getDebiteur()"
            ></mh-select>
            <b-col v-if="!debtor.ID.value" lg="12" class="mt-2">
              <label>Derniers débiteurs créés ou modifiés</label>
              <b-list-group>
                <b-list-group-item
                  variant="light"
                  href="#"
                  v-for="(d, i) in last_debtors"
                  :key="i"
                  @click.prevent="getDebiteur(d.ID)"
                >
                  {{ format(d) }}
                </b-list-group-item>
              </b-list-group>
            </b-col>
            <b-col lg="12">
              <b-row v-if="debtor.ID.value">
                <mh-input
                  mh-class="col-12"
                  field="nom_soc"
                  :table="debtor"
                  labelColsLg="0"
                  readonly
                ></mh-input>
                <mh-input
                  mh-class="col-6"
                  field="nom"
                  :table="debtor"
                  labelColsLg="0"
                  readonly
                ></mh-input>
                <mh-input
                  mh-class="col-6"
                  field="prenom"
                  :table="debtor"
                  labelColsLg="0"
                  readonly
                ></mh-input>
                <mh-input
                  mh-class="col-6"
                  field="telephone"
                  labelColsLg="0"
                  :table="debtor"
                  readonly
                ></mh-input>
                <mh-input
                  mh-class="col-6"
                  field="gsm"
                  :table="debtor"
                  labelColsLg="0"
                  readonly
                ></mh-input>
                <mh-input
                  mh-class="col-6"
                  field="email"
                  :table="debtor"
                  readonly
                  labelColsLg="0"
                ></mh-input>
                <mh-input
                  mh-class="col-12"
                  field="rue1"
                  :table="debtor"
                  labelColsLg="0"
                  readonly
                ></mh-input>
                <mh-input
                  mh-class="col-12"
                  labelColsLg="0"
                  field="rue2"
                  :table="debtor"
                  readonly
                ></mh-input>
                <mh-input
                  mh-class="col-6"
                  field="localite"
                  :table="debtor"
                  labelColsLg="0"
                  readonly
                ></mh-input>
                <mh-input
                  mh-class="col-6"
                  field="codepostal"
                  :table="debtor"
                  labelColsLg="0"
                  readonly
                ></mh-input>
                <mh-input
                  mh-class="col-6"
                  field="pays"
                  :table="debtor"
                  labelColsLg="0"
                  readonly
                ></mh-input>
                <mh-input
                  mh-class="col-6"
                  labelColsLg="0"
                  field="tva"
                  :table="debtor"
                  readonly
                ></mh-input>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" class="mt-3">
              <b-button
                size="sm"
                v-if="debtor.ID.value"
                variant="info"
                @click="debtor.ID.value = null"
                >Revenir à la liste des débiteurs récents</b-button
              >
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="9">
        <b-card class="mb-3 bg-light shadow" v-if="debtor.ID.value">
          <h6 class="card-title">Informations concernant le mandat</h6>
          <b-row>
            <b-col lg="12" v-if="debtor.nom_soc">
              Nom du débiteur :
              <template v-if="company(debtor.nom_soc.value)">
                <span v-html="company(debtor.nom_soc.value)"></span>
              </template>
              <template v-else>
                <span
                  v-html="fullName(debtor.prenom.value, debtor.nom.value)"
                ></span>
              </template>
            </b-col>
            <b-col lg="12">
              <b-row>
                <mh-input
                  mh-class="col-4"
                  labelColsLg="0"
                  field="ref_creancier"
                  :table="mandat"
                  autofocus
                >
                </mh-input>
                <mh-input
                  labelColsLg="0"
                  mh-class="col-8"
                  field="note"
                  :table="mandat"
                >
                </mh-input>
              </b-row>
            </b-col>
            <b-col lg="12">
              <h6 class="card-title">Factures</h6>
              <mh-table-editable
                @validation="process_validation($event)"
                ref="invoiceTable"
                class="mt-3"
                numbering
                v-model="creditorsInvoices"
                :fields="fieldsInvoices"
              >
              </mh-table-editable>
            </b-col>
            <b-col lg="12" class="mt-3">
              <b-button
                size="sm"
                @click="openWarrant()"
                :disabled="!openable"
                variant="success"
                v-if="debtor.ID.value"
                >Ouvrir le mandat</b-button
              >
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import String from "@/services/String.js";
import warrants from "@/services/warrants";
import creditors from "@/services/creditors";
import debtors from "@/services/debtors";
import MhInput from "@/components/MhInput.vue";
import MhSelect from "@/components/MhSelect.vue";
import MhTableEditable from "@/components/MhTableEditable.vue";
export default {
  name: "warrant-open",
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    debiteur: {
      type: [Number, String],
      default: 0,
    },
  },
  components: {
    MhInput,
    MhSelect,
    MhTableEditable,
  },
  data() {
    return {
      mandat: {},
      creditor: {},
      last_debtors: [],
      openable: false,
      loaded: false,
      ApiDebtors: debtors,
      debtor: {
        ID: {
          value: null,
        },
      },
      sendMail: false,
      tabindex: 0,
      fieldsInvoices: [
        {
          key: "numero",
          label: "Numéro de facture",
          type: "varchar",
          required: true,
        },
        {
          key: "date",
          label: "Date",
          type: "date",
          trigger: (item) =>
            item.echeance.value == ""
              ? (item.echeance.value = item.date.value)
              : null,
        },
        {
          key: "echeance",
          label: "Échéance",
          type: "date",
        },
        {
          key: "montant",
          label: "Montant",
          type: "float",
          trigger: (item) => {
            item.montant.value = Number(item.montant.value).toFixed(2);
            item.solde.value = Number(item.solde.value)
              ? item.solde.value
              : item.montant.value;
          },
          append: "€",
        },
        {
          key: "solde",
          label: "Solde",
          type: "float",
          default: 0,
          trigger: (item) =>
            (item.solde.value = Number(item.solde.value).toFixed(2)),
          append: "€",
        },
        {
          key: "reference_client",
          label: "Référence client",
          type: "varchar",
        },
      ],
      creditorsInvoices: [],
      proposition: "",
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats",
          to: { name: "warrants" },
        },
      ],
    };
  },
  created() {
    this.getLastDebtors();
    warrants
      .get(this.$route.params.id)
      .then((response) => {
        this.mandat = response.data;
        this.items.push({
          text:
            "Ouverture du mandat n° " +
            this.mandat.ID.value +
            " (" +
            this.mandat.creancier.nom_soc.value +
            ")",
          active: true,
        });
        this.mandat.modeID.value = 1;
        if (this.mandat.lastNegoDate.value == "0000-00-00") {
          this.mandat.lastNegoDate.value = null;
        }
        if (this.mandat.date_cloture.value == "0000-00-00") {
          this.mandat.date_cloture.value = null;
        }
        creditors.get(this.mandat.creancierID.value).then((response) => {
          this.creditor = response.data;
          this.mandat.negotiateurID.value = this.$store.getters.negoID;
          this.mandat.realCreancier_nom_soc = this.creditor.nom_soc;
          this.mandat.realCreancier_address1 = this.creditor.address1;
          this.mandat.realCreancier_address2 = this.creditor.address2;
          this.mandat.realCreancier_codepostal = this.creditor.codepostal;
          this.mandat.realCreancier_localite = this.creditor.localite;
          this.mandat.realCreancier_pays = this.creditor.pays;
          this.mandat.realCreancier_qualiteALL = this.creditor.qualiteALL;
          this.mandat.realCreancier_qualiteEN = this.creditor.qualiteEN;
          this.mandat.realCreancier_qualiteFR = this.creditor.qualiteFR;
          this.mandat.realCreancier_qualiteNL = this.creditor.qualiteNL;
          this.mandat.realCreancier_telephone = this.creditor.telephone;
          this.mandat.realCreancier_tva = this.creditor.tva;
          this.mandat.realCreancier_tva_pays = this.creditor.tva_pays;
          this.mandat.commission = this.creditor.defaultCommission;
          this.mandat.clause_penale = this.creditor.clause_penale;
          this.mandat.indemnite_minimum = this.creditor.indemnite_min;
          this.mandat.interet_taux = this.creditor.taux_interet;
        });
        this.loaded = true;
        if (this.$props.debiteur) {
          this.tabindex = 1;
          console.log(this.tabindex);
          this.getDebiteur(this.$props.debiteur);
        }
      })
      .catch((error) => {
        console.log(error);
        this.loaded = true;
      });
  },
  methods: {
    process_validation(e) {
      this.openable = e;
    },
    format(d) {
      let str = "";
      if (d.nom_soc.trim() !== "") {
        str += d.nom_soc;
      }
      if ((d.prenom + " " + d.nom).trim() !== "") {
        if (str == "") {
          str += d.prenom + " " + d.nom;
        } else {
          str += " (" + d.prenom + " " + d.nom + ")";
        }
      }
      return str;
    },
    goTranslate() {
      creditors
        .translateQuality(this.creditor.qualiteFR.value)
        .then((response) => {
          if (response.data.length > 0) {
            this.proposition = response.data[0].fr;
            this.mandat.realCreancier_qualiteNL.value = response.data[0].nl;
            this.mandat.realCreancier_qualiteEN.value = response.data[0].en;
            this.mandat.realCreancier_qualiteALL.value = response.data[0].all;
          }
        });
    },
    suggestAddress(payload) {
      this.mandat.realCreancier_address1.value = payload.route || "";
      if (payload.street_number) {
        this.mandat.realCreancier_address1.value +=
          ", " + payload.street_number;
      }
      this.mandat.realCreancier_address2.value = "";
      this.mandat.realCreancier_localite.value = payload.city || "";
      this.mandat.realCreancier_pays.value = payload.country || "";
      this.mandat.realCreancier_codepostal.value = payload.postal_code || "";
    },
    getLastDebtors() {
      debtors.last_updated().then((response) => {
        this.last_debtors = response.data;
      });
    },
    getDebiteur(id = null) {
      if (id !== null) {
        this.mandat.debiteurID.value = id;
      }
      if (this.mandat.debiteurID.value == 0) return;
      this.ApiDebtors.get(this.mandat.debiteurID.value).then((response) => {
        this.debtor = response.data;
      });
    },
    fullName(a, b) {
      return String.fullName(a, b);
    },
    ucfirst(a) {
      return String.ucfirst(a);
    },
    company(a) {
      return String.company(a);
    },
    openWarrant() {
      warrants
        .open(this.mandat.ID.value, {
          sendMail: this.sendMail,
          debtor: this.debtor.ID.value,
          invoices: this.creditorsInvoices,
          warrant: this.mandat,
        })
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("Mandat ouvert", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            this.$router.push({
              name: 'warrantView', params: { id: response.data.id } 
            });
          } else if (response.data.fail) {
            for (let el in this.mandat) {
              this.mandat[el].error = false;
            }
            response.data.fail.forEach((element) => {
              this.mandat[element.field].error = element.errors.join(" ; ");
            });
            this.renderFields++;
          } else if (response.data.error) {
            this.$bvToast.toast("Erreur : " + response.data.error, {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "danger",
              autoHideDelay: 2000,
              solid: false,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>